var map = {
	"./cluster.png": 139,
	"./markers/generated/alpine_climbing-a.png": 114,
	"./markers/generated/alpine_climbing-b.png": 115,
	"./markers/generated/alpine_tour-a.png": 116,
	"./markers/generated/alpine_tour-b.png": 117,
	"./markers/generated/mountain_hiking-a.png": 118,
	"./markers/generated/mountain_hiking-b.png": 119,
	"./markers/generated/ski_tour-a.png": 120,
	"./markers/generated/ski_tour-b.png": 121,
	"./markers/generated/snowshoe_tour-a.png": 112,
	"./markers/generated/snowshoe_tour-b.png": 113,
	"./markers/generated/via_ferrata-a.png": 122,
	"./markers/generated/via_ferrata-b.png": 123,
	"./public_transport_stops/Aufzug.png": 140,
	"./public_transport_stops/Bus.png": 141,
	"./public_transport_stops/Bus_Kabinenbahn.png": 142,
	"./public_transport_stops/Bus_Metro.png": 143,
	"./public_transport_stops/Bus_Schiff.png": 144,
	"./public_transport_stops/Bus_Standseilbahn.png": 145,
	"./public_transport_stops/Bus_Tram.png": 146,
	"./public_transport_stops/Bus_Tram_Standseilbahn.png": 147,
	"./public_transport_stops/Bus_Tram_Zahnradbahn.png": 148,
	"./public_transport_stops/Bus_Zug.png": 149,
	"./public_transport_stops/Bus_Zug_Tram.png": 150,
	"./public_transport_stops/Kabinenbahn.png": 151,
	"./public_transport_stops/Kabinenbahn_Sesselbahn.png": 152,
	"./public_transport_stops/Metro.png": 153,
	"./public_transport_stops/Reiner_BP.png": 154,
	"./public_transport_stops/Schiff.png": 155,
	"./public_transport_stops/Sesselbahn.png": 156,
	"./public_transport_stops/Standseilbahn.png": 157,
	"./public_transport_stops/Standseilbahn_Kabinenbahn.png": 158,
	"./public_transport_stops/Standseilbahn_Kabinenbahn_Sesselbahn.png": 159,
	"./public_transport_stops/Standseilbahn_Schiff.png": 160,
	"./public_transport_stops/Tram.png": 161,
	"./public_transport_stops/Tram_Schiff.png": 162,
	"./public_transport_stops/Zahnradbahn.png": 163,
	"./public_transport_stops/Zahnradbahn_Kabinenbahn.png": 164,
	"./public_transport_stops/Zahnradbahn_Kabinenbahn_Sesselbahn.png": 165,
	"./public_transport_stops/Zahnradbahn_Schiff.png": 166,
	"./public_transport_stops/Zug.png": 167,
	"./public_transport_stops/Zug_Kabinenbahn.png": 168,
	"./public_transport_stops/Zug_Metro.png": 169,
	"./public_transport_stops/Zug_Schiff.png": 170,
	"./public_transport_stops/Zug_Standseilbahn.png": 171,
	"./public_transport_stops/Zug_Tram.png": 172
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/img/icons \.png$
// module id = 138
// module chunks = 0 2